import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

import TableView from "@/views/TableView";
import WizardGoodsStepper from "@/components/wizard/goods/GoodsComponent";
import WizardViewPackages from "@/components/wizard/packages/PackagesComponent";

const routes = [
  { path: "/", component: TableView },
  { path: "/goods", component: WizardGoodsStepper },
  { path: "/packages", component: WizardViewPackages },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
